<template>
  <Modal
    v-model="show"
    title=""
    :closable="false"
    :mask-closable="false"
    :ok-text="okText"
    :cancel-text="cancelText"
    width="810px"
    :footer-hide="true"
    class-name="df-modal"
  >
    <div class="df-modal-body">
      <p class="df-modal-title">{{ title }}</p>
      <div class="df-modal-content">
        <slot></slot>
      </div>
      <div class="df-modal-btngroup">
        <Button
          v-if="!noCancel"
          @click="
            $emit('Cancel')
            show = false
          "
          >{{ cancelText }}</Button
        >
        <Button
          @click="
            $emit('Ok')
            show = false
          "
          type="primary"
          >{{ okText }}</Button
        >
      </div>
      <Button v-if="isJump" type="text" class="jump-over" @click="$emit('jumpOver')">跳过</Button>
    </div>
  </Modal>
</template>

<script>
import { Modal, Button } from 'view-design'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    title: {
      type: String,
      default: '提 示'
    },
    okText: {
      type: String,
      default: '确 定'
    },
    cancelText: {
      type: String,
      default: '取 消'
    },
    //只显示是的按钮
    noCancel: {
      type: Boolean,
      default: false
    },
    isJump: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Modal,
    Button
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/index.scss';
.df-modal {
  .ivu-modal-content {
    height: 620px;
  }
  .ivu-modal-header {
    display: none;
  }
  &-body {
    padding: 40px;
  }
  &-title {
    font-size: 18px;
    font-weight: bold;
  }
  &-content {
    height: 380px;
    margin: 60px 0 20px;
    overflow-y: auto;
  }
  &-btngroup {
    display: flex;
    justify-content: space-evenly;
    button {
      margin: 0 5px;
    }
  }
  .jump-over {
    position: absolute;
    right: 0;
    bottom: 20px;
  }
}

$primary: #015fff;
$primaryHover: #004ed2;

.ivu-btn {
  height: 40px;
  line-height: 40px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  font-size: 16px;
  &-primary {
    background-color: $primary;
    color: #fff;
    &:hover {
      background-color: $primaryHover;
      border-color: $primaryHover;
    }
  }
  &-default {
    border-color: $primary;
    color: $primary;
    &:hover {
      border-color: $primaryHover;
      color: $primaryHover;
    }
  }
  span {
    line-height: 40px;
    margin: 0 auto;
    font-size: 16px;
  }
  width: 120px;
  &.type1 {
    width: 90px;
  }
  &.type2 {
    width: 120px;
  }
}
</style>
